import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { refreshCertification } from '../../utils/certificationCache';
import { IRQCallbacks } from '../../types/my-types';
import { ITrainingSetUpdateParams } from '../../api/types';

type IuseTrainingSetUpdateProps = {
  trainingSetId: string;
  data: ITrainingSetUpdateParams;
};

export const useTrainingSetUpdate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const cache = useQueryClient();

  return useMutation({
    mutationFn: async (data: IuseTrainingSetUpdateProps) => {
      return await (await glynt).trainingSet.update(data.trainingSetId, data.data);
    },

    ...callbacks,

    onSettled: async (data, error, variables) => {
      if (!error) {
        refreshCertification(cache, variables.trainingSetId);
      }
      callbacks?.onSettled?.();
    }
  });
};
